import React from "react";
import { Link } from "react-router-dom";
import AppLayout from "../components/AppLayout";
import {
    GraduationCap,
    Bell,
    Phone,
    Info,
    ChevronRight,
    ShieldCheck,
    Mail,
    Building2,
    ExternalLink,
    Share2,
    Home,
    Package,
    FileText,
    MessageSquare,
} from "lucide-react";

const openChat = () => {
    document.querySelector('[data-testid="chat-trigger"]')?.click();
};

const share = async () => {
    if (navigator.share) {
        try {
            await navigator.share({
                title: "NSP Noleggio - Nolo Service Point",
                text: "Noleggio attrezzature e mezzi per edilizia",
                url: window.location.origin,
            });
        } catch (_) {
            /* utente annulla */
        }
    } else {
        navigator.clipboard.writeText(window.location.origin);
        alert("Link copiato!");
    }
};

const MenuPage = () => {
    return (
        <AppLayout pageTitle="Menu" showBack backTo="/">
            <div className="max-w-2xl mx-auto px-4 sm:px-6 py-6 md:py-10">
                {/* Sezione: Navigazione principale */}
                <Section title="Navigazione">
                    <MenuLink to="/" icon={Home} label="Home" />
                    <MenuLink to="/catalogo" icon={Package} label="Catalogo Mezzi" />
                    <MenuLink to="/preventivo" icon={FileText} label="Preventivo" />
                    <MenuButton onClick={openChat} icon={MessageSquare} label="Chat AI" />
                </Section>

                <Section title="Servizi">
                    <MenuLink to="/corsi" icon={GraduationCap} label="Corsi & Patentini" />
                    <MenuLink to="/notifiche" icon={Bell} label="Notifiche & Preferenze" />
                </Section>

                <Section title="Informazioni">
                    <MenuLink to="/contatti" icon={Info} label="Chi Siamo & Contatti" />
                    <MenuA href="tel:+393272237610" icon={Phone} label="Chiama 327 2237610" />
                    <MenuButton
                        onClick={() => {
                            const a = ["info", "noloservicepoint", "it"];
                            window.location.href = `mailto:${a[0]}@${a[1]}.${a[2]}`;
                        }}
                        icon={Mail}
                        label="Scrivici via email"
                    />
                    <MenuA
                        href="https://maps.google.com/?q=Via+Salaria+Vecchia+31,+Osteria+Nuova+di+Poggio+Moiano"
                        icon={Building2}
                        label="Sede: Salaria Vecchia 31"
                        external
                    />
                </Section>

                <Section title="Altro">
                    <MenuButton onClick={share} icon={Share2} label="Condividi NSP" />
                </Section>

                {/* Footer info */}
                <div className="mt-10 text-center text-xs text-zinc-500 space-y-1">
                    <div className="inline-flex items-center gap-1.5 text-nsp-green font-bold uppercase tracking-widest">
                        <ShieldCheck className="w-3 h-3" />
                        A norma D.Lgs. 81/08
                    </div>
                    <div>
                        NSP Nolo Service Point Soc. Coop. &middot; BigMat Ediltutto
                    </div>
                    <div className="opacity-60">v1.0 &middot; PWA installabile</div>
                </div>
            </div>
        </AppLayout>
    );
};

const Section = ({ title, children }) => (
    <div className="mb-6">
        <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-zinc-500 px-3 mb-2">
            {title}
        </div>
        <div className="bg-white border border-nsp-border divide-y divide-nsp-border">
            {children}
        </div>
    </div>
);

const rowClass =
    "flex items-center gap-3 px-4 py-4 hover:bg-nsp-bg active:bg-nsp-yellow/20 transition-colors w-full text-left";

const MenuLink = ({ to, icon: Icon, label }) => (
    <Link to={to} className={rowClass} data-testid={`menu-link-${to.slice(1) || "home"}`}>
        <Icon className="w-5 h-5 text-nsp-green flex-shrink-0" strokeWidth={2} />
        <span className="flex-1 text-nsp-green font-semibold">{label}</span>
        <ChevronRight className="w-4 h-4 text-zinc-400" />
    </Link>
);

const MenuButton = ({ onClick, icon: Icon, label }) => (
    <button type="button" onClick={onClick} className={rowClass}>
        <Icon className="w-5 h-5 text-nsp-green flex-shrink-0" strokeWidth={2} />
        <span className="flex-1 text-nsp-green font-semibold">{label}</span>
        <ChevronRight className="w-4 h-4 text-zinc-400" />
    </button>
);

const MenuA = ({ href, icon: Icon, label, external }) => (
    <a
        href={href}
        target={external ? "_blank" : undefined}
        rel={external ? "noopener noreferrer" : undefined}
        className={rowClass}
    >
        <Icon className="w-5 h-5 text-nsp-green flex-shrink-0" strokeWidth={2} />
        <span className="flex-1 text-nsp-green font-semibold">{label}</span>
        {external ? (
            <ExternalLink className="w-4 h-4 text-zinc-400" />
        ) : (
            <ChevronRight className="w-4 h-4 text-zinc-400" />
        )}
    </a>
);

export default MenuPage;
